import { EmailConfirmationStage } from 'client/types';
import { SendEmailParams } from 'client/types/utils';

import { routes } from '../../lib/routes';
import { callApi } from '../utils';

interface EmailConfirmationResponse {
    stage: EmailConfirmationStage;
    skillId: string;
}

export function sendEmail(data: SendEmailParams) {
    return callApi({ method: 'POST', url: routes.app.appStoreApi('email/send'), data });
}

export function confirmEmail(token: string | (string | null)[]) {
    return callApi<EmailConfirmationResponse>({
        method: 'POST',
        url: routes.app.appStoreApi('email/confirm'),
        data: { token },
    });
}
